var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.333008,
    y1: 1,
    x2: 17.333,
    y2: 1,
    stroke: "#2B5297"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.333008,
    y1: 6,
    x2: 17.333,
    y2: 6,
    stroke: "#2B5297"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.333008,
    y1: 11,
    x2: 17.333,
    y2: 11,
    stroke: "#2B5297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.5e537f1f2a4797bc8351a4bb3a7d6d67.svg";
export { ForwardRef as ReactComponent };